// ========================================
// ================== V3 ==================
// ========================================

import * as aTypes from "./actionTypes";

// ============ MY USERS  ============
export const initFetchBestplays = (activeUser = null) => {
  return {
    type: aTypes.V3_BESTPLAYS_INIT,
    activeUser: activeUser,
  };
};

export const fetchBestplaysSuccess = (bestplays) => {
  return {
    type: aTypes.V3_BESTPLAYS_SET,
    bestplays: bestplays,
  };
};

export const fetchBestplaysFail = (error) => {
  return {
    type: aTypes.V3_BESTPLAYS_FETCH_FAIL,
    error: error,
  };
};
